<template>
    <div class="selector">
        <div class="value" v-html='html(selected())'></div>
        <div class="options">
            <simplebar data-simplebar-auto-hide="false" data-simplebar-force-visible="true">
                <div class="option" v-for="option in options" v-bind:key="option.value" v-html="html(option)" @click="onClick(option)"/>
            </simplebar>
        </div>
    </div>
</template>

<script>
import 'simplebar/dist/simplebar.min.css'

export default {
  props: ['html', 'name', 'options', 'value'],
  methods: {
    selected () {
      var r = null
      this.options.forEach(i => {
        if (i.value === this.value) r = i
      })
      return r
    },
    onClick (i) {
      this.$emit('input', i.value)
    }
  }
}
</script>

<style>

.selector {
  color: #000000;
  cursor: pointer;
  font-family: 'AvenirNext';
  font-size: 1em;
  font-weight: 400;
  margin: 0 0 0.5em 0;
  position: relative;
  width: 100%;
}

.selector .value {
  position: relative;
  margin-bottom: 0.1em;
}

.selector .options {
  display: none;
  position: absolute;
  z-index: 1;
}

.selector.active .options {
  display: block;
}

.selector .value, .selector .options {
  background-color: white;
  border: solid 1px #e0e0e0;
  border-radius: 0.3em;
  width: 100%;
}

.selector .options > div {
  max-height: 14em;
}

.selector .value, .selector .option {
  padding: 0.8em 1em;
}

.selector .option:hover {
  background-color: #e1e1e1;
}

.selector .simplebar-scrollbar::before {
  background-color:rgba(0, 0, 0, 0.3);
}

</style>
